import type { DataTableSizeSetting } from '../types';

export default <DataTableSizeSetting[]>[
  {
    label: 'Table Size',
    disabled: true,
  },
  {
    label: 'Compact',
    value: 'compact',
  },
  {
    label: 'Normal',
    value: 'default',
  },
  {
    label: 'Large',
    value: 'large',
  },
]